export enum TrustedContactOrigin {
  ORGANISATION_CONTACTS = 'organisation-contacts',
  COMPANY_CONTACTS = 'company-contacts',
}
